import React from 'react';
import { StyledLink } from './styles';

const Link = ({ to, children }) => <StyledLink to={to}>{children}</StyledLink>;

export default Link;
